module.exports = __webpack_public_path__ + "static/media/36.a7dcb63a.jpg";